import { render, staticRenderFns } from "./Variant_information.vue?vue&type=template&id=c849d6d2&scoped=true&"
import script from "./Variant_information.vue?vue&type=script&lang=js&"
export * from "./Variant_information.vue?vue&type=script&lang=js&"
import style0 from "./Variant_information.vue?vue&type=style&index=0&id=c849d6d2&lang=scss&parent=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c849d6d2",
  null
  
)

export default component.exports